import { VimeoPlayer } from "@/components/Vimeo";

const VIMEO_MP4 =
    "https://player.vimeo.com/progressive_redirect/playback/1085457682/rendition/1080p/file.mp4%20%281080p%29.mp4?loc=external&log_user=0&signature=3dded750ab90c7020f9261c2223b94d7b0cfba6280dfa6461e19c286b53742da";

const VimeoTest = () => {
    return (
        <div className="max-w-3xl mx-auto p-4 space-y-4">
            <h1 className="text-xl font-bold">Vimeo Player Test (Direct MP4)</h1>
            <p className="text-sm text-gray-500">
                Native &lt;video&gt; with autoplay + muted + playsinline.
            </p>
            <div className="rounded-lg overflow-hidden bg-black shadow-xl">
                <VimeoPlayer
                    videoId={VIMEO_MP4}
                    onPlay={() => console.log("✅ onPlay fired")}
                    onError={() => console.error("❌ onError fired")}
                    onProgress={(p) => console.log(`progress: ${p.toFixed(1)}%`)}
                />
            </div>
        </div>
    );
};

export default VimeoTest;
